var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBtnTablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#CEEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.139 20.6028L18.7174 18.1813C20.6753 15.9474 20.5889 12.5464 18.4581 10.4157C16.2373 8.19478 12.6365 8.19478 10.4157 10.4157C8.19478 12.6365 8.19478 16.2373 10.4157 18.4581C12.5464 20.5889 15.9474 20.6753 18.1813 18.7174L20.6028 21.139C20.7508 21.287 20.9909 21.287 21.139 21.139C21.287 20.9909 21.287 20.7508 21.139 20.6028ZM17.922 10.9518C19.8467 12.8766 19.8467 15.9972 17.922 17.922C15.9972 19.8467 12.8766 19.8467 10.9518 17.922C9.02706 15.9972 9.02706 12.8766 10.9518 10.9518C12.8766 9.02706 15.9972 9.02706 17.922 10.9518Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBtnTablet);
export default __webpack_public_path__ + "static/media/search-btn-tablet.8d88f810af5abedea288f28879b2a148.svg";
export { ForwardRef as ReactComponent };